// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* STORYBOOK
* If you add any variable, remember to map it into the proper Story
*/
/**
* Color palette - Facile.it
* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1
*/
/* Primary */
/* Action */
/* Alert */
/* Success */
/* Help */
/* Error */
/* Chick */
/* Text */
/* Grey */
/* Neutral/warm */
/* Neutral/cold */
/* Opacity/Grey */
/* Opacity/White */
/* Opacity/Colors */
/**
* Color map - Facile.it
*/
/**
* @deprecated use Color - Facile.it palette
*/
/**
* Removes a specific item from a list.
*
* @param {list} \$list List. @param {integer} \$index Index.
* @return {list} Updated list.
*/
/**
* Gets a value from a map.
*
* @param {map} \$map Map.
* @return {string} Value.
*/
.shark .position-fixer {
  background-color: transparent;
  position: fixed;
  bottom: 0;
  z-index: 100;
}
.shark .position-fixer.position-bottom-dx {
  right: 5%;
}
@media (max-width: 1900px) {
  .shark .position-fixer.position-bottom-dx {
    right: 0%;
  }
}
.shark .position-fixer.position-bottom-sx {
  left: 5%;
}
@media (max-width: 1900px) {
  .shark .position-fixer.position-bottom-sx {
    left: 5%;
  }
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./node_modules/@facile-it/shark-morph/components/PositionFixer/positionFixer.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;CAGC;AACD,YAAY;AACZ,WAAW;AACX,UAAU;AACV,YAAY;AACZ,SAAS;AACT,UAAU;AACV,UAAU;AACV,SAAS;AACT,SAAS;AACT,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;AACjB,kBAAkB;AAClB,mBAAmB;AACnB;;CAEC;AACD;;CAEC;AACD;;;;;CAKC;AACD;;;;;CAKC;AACD;EACE,6BAA6B;EAC7B,eAAe;EACf,SAAS;EACT,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE,QAAQ;AACV;AACA;EACE;IACE,QAAQ;EACV;AACF;;AAEA,wzEAAwzE","sourcesContent":["/**\n* STORYBOOK\n* If you add any variable, remember to map it into the proper Story\n*/\n/**\n* Color palette - Facile.it\n* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1\n*/\n/* Primary */\n/* Action */\n/* Alert */\n/* Success */\n/* Help */\n/* Error */\n/* Chick */\n/* Text */\n/* Grey */\n/* Neutral/warm */\n/* Neutral/cold */\n/* Opacity/Grey */\n/* Opacity/White */\n/* Opacity/Colors */\n/**\n* Color map - Facile.it\n*/\n/**\n* @deprecated use Color - Facile.it palette\n*/\n/**\n* Removes a specific item from a list.\n*\n* @param {list} $list List. @param {integer} $index Index.\n* @return {list} Updated list.\n*/\n/**\n* Gets a value from a map.\n*\n* @param {map} $map Map.\n* @return {string} Value.\n*/\n.shark .position-fixer {\n  background-color: transparent;\n  position: fixed;\n  bottom: 0;\n  z-index: 100;\n}\n.shark .position-fixer.position-bottom-dx {\n  right: 5%;\n}\n@media (max-width: 1900px) {\n  .shark .position-fixer.position-bottom-dx {\n    right: 0%;\n  }\n}\n.shark .position-fixer.position-bottom-sx {\n  left: 5%;\n}\n@media (max-width: 1900px) {\n  .shark .position-fixer.position-bottom-sx {\n    left: 5%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
